import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
import Card from "components/card/custom";
import DivLoader from "components/divloader/DivLoader";
import React, { useState } from "react";
import { SettlementRowObj } from "..";
import CreatePaymentMethoddModal from "./CreatePaymentMethod";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader , PopoverArrow } from "@chakra-ui/react";
import { Portal } from '@chakra-ui/portal'
import {
  MdApproval,
  MdCancel,
  MdCheckBox,
  MdCheckCircle,
  MdCheckCircleOutline,
  MdCircle,
  MdDelete,
  MdOutlineCheck,
  MdHighlightOff,
  MdOutlineCircle,
  MdWarning
} from "react-icons/md";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Searchbox from "components/fields/Searchbox";
// import { getImaDownge } from "utils/commonFunction";
import { BsEyeFill, BsDownload, BsArrowUp, BsArrowDown } from "react-icons/bs";
import { BiEdit } from "react-icons/bi";
import Pagination from "components/pagination";
import toast from "react-hot-toast";
import {
  approvedSettlement,
  deleteSettlementReport,
  DownloadCSVSettlement,
  downloadSettlementReport,
  checkTransactionAvailableSettlementReport,
} from "api/settlement";
import { Modal, ModalBody, ModalContent, ModalOverlay  , ModalHeader , ModalFooter } from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import CrerateSettlementReport from "./CrerateSettlementReport";
import SettlementReport from "./settlementReport";
import InputField from "components/fields/InputField";
import { error } from "console";
import { FaCheckCircle } from "react-icons/fa";

import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { RiArrowUpDownFill } from "react-icons/ri";

function SettlementTable(props: {
  tableData: any;
  fetchAllsettlement: () => void;
  isLoading: boolean;
  page: number;
  setPage: any;
  totalpage: number;
  totalItems: number;
  currentPage: number;
  pageSize: number;
  setPageSize: any;
  roleData: any;
  timeZone: any;
  allCardType: any;
  onValueChange: (value: string) => void;
  allOrgDetails: any;
}) {
  const {
    tableData,
    fetchAllsettlement,
    page,
    setPage,
    currentPage,
    totalpage,
    totalItems,
    pageSize,
    setPageSize,
    roleData,
    timeZone,
    allCardType,
    onValueChange,
    allOrgDetails,
  } = props;
  let defaultData = tableData;

  
  let showPaymentName =
    roleData[0]?.payment_method?.value?.show_payment_method_name;

  // const { isOpen, onOpen, onClose } = useDisclosure();
  const [isOpenDelete, setIsopenDelete] = useState(false);
  const [payoutStatus, setPayoutStatus] = useState(false);
  const [settlmenetStatus, setSettlmenetStatus] = useState(false);
  const [DeleteRowId, setDeleteRowId] = useState("");
  const [isOpenApprove, setIsopenApprove] = useState(false);
  const [isApprove, setIsApprove] = useState(false);
  const [isDownloadFile, setIsDownloadFile] = useState(false);
  const [isApproveLoading, setIsApproveLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [isCloseModal, setIsCloseModal] =  useState<boolean>(false);
  const [isCloseAppModal, setIsCloseAppModal] =  useState<boolean>(false);
  const [markStatus, setMarkStatus] = useState("approved");
  const [loadingApproveSettlement, setLoadingApproveSettlement] = useState(false);
  const [isTransctionAvailable, setIsTransctionAvailable] = useState(false);
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const [searchVal, setSearchVal] = React.useState<any>("");
  const [data, setData] = React.useState(() => [...defaultData]);
  const [netPayout, setNetPayout] = React.useState({
    usdtForex: null,
    withdrawalFee: null,
    settlementFee: null,
    hash: null,
  });
  const [apprveErrors, setApproveErrors] = useState<any>({});
  const [USDTForexRate, setUSDTForexRate] = React.useState<any>([]);

  const handelOnDownloadCSV = (sid: any) => {
    // setLoading(true);
    downloadSettlementReport(sid)
      .then((response) => {
        const csvText = response;
        const blob = new Blob([csvText], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "generated_data.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Download Completed");
        setTimeout(() => {
          // setLoading(false);
        }, 2000);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ??
          "Something went wrong while downloading CSV"
        );
        setTimeout(() => {
          // setLoading(false);
        }, 2000);
      });
  };

  const deleteSettlementReportFun = (id: any) => {
    setIsDeleteLoading(true)
    deleteSettlementReport(DeleteRowId)
      .then((res) => {
        toast.success("Record deleted successfully!");
        setIsDeleteLoading(false)
        fetchAllsettlement();
        handleClose();
      })
      .catch((error) => {
        setIsDeleteLoading(false)
        toast.error("Something went wrong!");
      });
  };
  const handleDownloadReport = (data: any) => {
    setIsDownloadFile(true);
    downloadSettlementReport(data?.id)
      .then((res) => {
        toast.success("Success!");
        data.takeAPIResponse(res);
      })
      .catch((error) => {
        toast.error("Something went wrong!");
      })
      .finally(() => {
        setIsDownloadFile(false);
      });
  };

  const [TableApproveData, setTableApproveData] = useState<any>();
  
  const handlePressonEye = (infoData: any) => {
    setUSDTForexRate([]);
    setApproveErrors({});
    setNetPayout({ usdtForex: null, withdrawalFee: null, settlementFee: null, hash: null });
    setLoadingApproveSettlement(true);
    
    const settlementId = infoData?.row?.original?.id;
    checkTransactionAvailableSettlementReport(settlementId)
      .then((data: any) => {
        if (data?.Is_transction_available) {
          const settlementData = infoData?.row?.original;           
          setSettlmenetStatus(settlementData?.settlement_status === "approved");
          setPayoutStatus(settlementData?.payout_status === "paid");
          setNetPayout({
            usdtForex: settlementData?.usdtForex || null,
            settlementFee: settlementData?.settlement_fee ?? "",  
            withdrawalFee: settlementData?.withdrawal_fee ?? "", 
            hash: settlementData?.hash ?? "",
          });

          const forexRates = settlementData?.usdt_forex ?? [];
          if (forexRates.length > 0) {
            const forexMapped = forexRates.map((item: any) => {
              const currencySummary = settlementData?.settlement_history_details?.find(
                (s: any) => s.summary_currency === item.currency
              );
              return {
                currency: item.currency,
                forex_rate: Number(item.forex_rate),
                netPayOut:
                  Number(currencySummary?.summary_report_table_details?.net_payout || 0) *
                  Number(item.forex_rate),
              };
            });
            setUSDTForexRate(forexMapped);
          }

          setTableApproveData(settlementData);
          setIsopenApprove(true);
        } else {
          setIsopenApprove(false);
          toast.error("Oops! There are no transaction of clients for the organization in the selected date period.");
        }
      })
      .catch((error: any) => {
        setIsopenApprove(false);
        console.info(error);
      })
      .finally(() => {
        setLoadingApproveSettlement(false);
      });
  };

  const columns = [
    columnHelper.accessor("organization", {
      id: "organization", 
      header: () => (
        <p className="flex justify-start text-sm font-bold text-gray-900 dark:text-white">
          Organization Name
        </p>
      ),
      cell: (info: any) => (
        <div className="flex justify-start text-sm font-bold text-navy-700 dark:text-white">
          {info.row.original?.organization?.name}

        </div>
      ),
      sortingFn: (rowA, rowB) => {
        const nameA = rowA.original.organization?.name?.toLowerCase() || "";
        const nameB = rowB.original.organization?.name?.toLowerCase() || "";
    
        return nameA.localeCompare(nameB);
      },
      enableSorting: true,
    }),
    columnHelper.accessor("client", {
      id: "client",
      header: () => (
        <p className="flex justify-start text-sm font-bold text-gray-900 dark:text-white">
          Client Name
        </p>
      ),
      cell: (info: any) => (
        <div className="flex justify-start text-sm font-bold text-navy-700 dark:text-white">
          {info?.row.original?.client
            ?.map((m: any) => {
              return m?.name;
            })
            .join(", ")}
        </div>
      ),
      sortingFn: (rowA, rowB) => {
        const nameA = rowA.original.client
          ?.map((m: any) => m?.name)
          .join(", ")
          .toLowerCase() || "";
        const nameB = rowB.original.client
          ?.map((m: any) => m?.name)
          .join(", ")
          .toLowerCase() || "";
    
        return nameA.localeCompare(nameB);
      },
      enableSorting: true,
    }),
    columnHelper.accessor("created_at", {
      id: "created_at",
      header: () => (
        <p className="flex justify-start text-sm font-bold text-gray-900 dark:text-white">
          Created Date
        </p>
      ),
      cell: (info: any) => (
        <div className="flex justify-start text-sm font-bold text-navy-700 dark:text-white">
          {info.row.original?.created_at}
        </div>
      ),
      sortingFn: (rowA, rowB) => {
        return (
          new Date(rowA.original.created_at).getTime() -
          new Date(rowB.original.created_at).getTime()
        );
      },
      enableSorting: true,
    }),
    columnHelper.accessor("total_payout", {
      id: "total_payout",
      header: () => (
        <p className="flex justify-start text-sm font-bold text-gray-900 dark:text-white">
          Total Payout
        </p>
      ),
      cell: (info: any) => (
        <div className="flex justify-start text-sm font-bold text-navy-700 dark:text-white">
          {info?.row?.original?.is_settlement_approved
            ? info.row.original?.total_payout ? "$" + Number(info.row.original?.total_payout)?.toFixed(2) : "" : "-"}
        </div>
      ),
    }),
    columnHelper.accessor("settlement_status", {
      id: "settlement_status",
      header: () => (
        <p className="flex justify-start text-sm font-bold text-gray-900 dark:text-white">
          Settlement Status
        </p>
      ),
      cell: (info: any) => (
        <div className="flex justify-start text-sm font-bold text-navy-700 dark:text-white">
          {info?.row?.original?.settlement_status=='approved' ? (
            <button className="flex items-center gap-1.5">
              <MdCheckCircle className="h-5 w-5 text-teal-500" />
                <p className="rounded-lg bg-green-100 py-1 pl-0 pr-1 text-center uppercase first-letter:capitalize dark:bg-green-50">
                  <span className="px-2 text-center uppercase text-green-500">
                    approved
                  </span>
                </p>
            </button>
          ): (
            <button className="flex items-center gap-1.5">
              <MdCancel className="h-5 w-5 text-red-500" />
              <p className="rounded-lg bg-red-100 py-1 pl-0 pr-1 text-center uppercase first-letter:capitalize dark:bg-red-50">
                <span className="px-2 text-center uppercase text-red-500">
                  un-approved
                </span>
              </p>
            </button>
          )}
        </div>
      ),
    }),
    columnHelper.accessor("payout_status", {
      id: "payout_status",
      header: () => (
        <p className="flex justify-start text-sm font-bold text-gray-900 dark:text-white">
          Payment Status
        </p>
      ),
      cell: (info: any) => (
        <div className="flex justify-start text-sm font-bold text-navy-700 dark:text-white">
          {info?.row?.original?.payout_status=='paid' ? (
            <button className="flex items-center gap-1.5">
              <MdCheckCircle className="h-5 w-5 text-teal-500" />
                <p className="rounded-lg bg-green-100 py-1 pl-0 pr-1 text-center uppercase first-letter:capitalize dark:bg-green-50">
                  <span className="px-2 text-center uppercase text-green-500">
                    paid
                  </span>
                </p>
            </button>
          ): (
            <button className="flex items-center gap-1.5">
              <MdCancel className="h-5 w-5 text-red-500" />
              <p className="rounded-lg bg-red-100 py-1 pl-0 pr-1 text-center uppercase first-letter:capitalize dark:bg-red-50">
                <span className="px-2 text-center uppercase text-red-500">
                  unpaid
                </span>
              </p>
            </button>
          )}
        </div>
      ),
    }),
    columnHelper.accessor("id", {
      id: "id",
      header: () => (
        <p className="text-sm font-bold text-gray-900 dark:text-white">
          ACTION
        </p>
      ),
      cell: (info: any) => {
        const settlementStatus = info?.row?.original?.settlement_status;
        const payoutStatus = info?.row?.original?.payout_status;

        let tooltipText = "";
        let clickable = "yes";

        if (settlementStatus === "approved" && payoutStatus === "unpaid") {
          tooltipText = "Settlement Approved & Unpaid";
          clickable = 'yes';
        } else if (settlementStatus === "approved" && payoutStatus === "paid") {
          tooltipText = "Settlement Approved & Paid";
          clickable = 'no';
        } else if (settlementStatus === "unapproved" && payoutStatus === "unpaid") {
          tooltipText = "Approve Settlement";
          clickable = 'yes';
        } else if (settlementStatus === "approved" && payoutStatus === "unpaid") {
          tooltipText = "Pay Settlement";
          clickable = 'yes';
        }

        const isApproved =
          settlementStatus === "approved" &&
          (payoutStatus === "paid" || payoutStatus === "unpaid");
        return (
          <p className="flex items-center gap-3 text-lg font-bold">
            <button className="outline-none disabled:cursor-not-allowed disabled:opacity-50">
              {roleData?.[0]?.settlement?.value?.approve_settlement && clickable == "no" ? (
                  <Popover trigger="hover" placement="bottom">
                    <PopoverTrigger>
                      <span className="inline-flex">
                        <FaCheckCircle
                          className="h-5 w-5 cursor-pointer text-blue-500"
                        />
                      </span>
                    </PopoverTrigger>
                    <Portal>
                      <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
                        <PopoverHeader>
                          <span className="text-sm  font-bold text-white">
                        {tooltipText}
                        </span>
                        </PopoverHeader>
                        <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
                      </PopoverContent>
                    </Portal>
                  </Popover>
                ) : (
                  <Popover trigger="hover" placement="bottom">
                    <PopoverTrigger>
                      <span className="inline-flex">
                        <MdOutlineCircle
                          className="h-5 w-5 cursor-pointer text-blue-500"
                          onClick={() => {
                            handlePressonEye(info);
                          }}
                        />
                      </span>
                    </PopoverTrigger> 
                    <Portal>
                      <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
                        <PopoverHeader>
                          <span className="text-sm  font-bold text-white">
                        {tooltipText}
                        </span>
                        </PopoverHeader>
                        <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
                      </PopoverContent>
                    </Portal>
                  </Popover>
                )
              }
            </button>
            {roleData?.[0]?.settlement?.value?.download_settlement&&
              <SettlementReport
                settlementInfo={info}
                handleDownloadReport={handleDownloadReport}
                fetchAllsettlement={fetchAllsettlement}
              />
            }
            {settlementStatus === "unapproved" && roleData?.[0]?.settlement?.value?.edit_settlement && (
                <CrerateSettlementReport
                  fetchAllsettlement={fetchAllsettlement}
                  allOrgDetails={allOrgDetails}
                  info={info}
                />
            )}
            {/* {roleData?.[0]?.settlement?.value?.edit_settlement && (
              <CrerateSettlementReport
                fetchAllsettlement={fetchAllsettlement}
                allOrgDetails={allOrgDetails}
                info={info}
              />
            )} */}
            {settlementStatus === "unapproved" && roleData?.[0]?.settlement?.value?.delete_settlement && (
              <Popover trigger="hover" placement="bottom">
                <PopoverTrigger>
                  <span className="inline-flex">
                    <MdDelete
                      onClick={() => {
                        // deleteSettlementReportFun(info.row.original?.id)
                        setIsopenDelete(true);
                        setDeleteRowId(info?.row?.original?.id);
                      }}
                      className="h-5 w-5 cursor-pointer font-bold text-red-500"
                    />
                  </span>
                </PopoverTrigger>  
                <Portal > 
                  <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
                    <PopoverHeader>
                      <span className="text-sm  font-bold text-white">
                    Delete Settlement
                    </span>
                    </PopoverHeader>
                    <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
                  </PopoverContent>
                </Portal>
              </Popover>
            )}
          </p>
        )
      },
      enableSorting:false
    }),
  ]; 

  const columns2 = [
    columnHelper.accessor("organization", {
      id: "organization", 
      header: () => (
        <p className="flex justify-start text-sm font-bold text-gray-900 dark:text-white">
          Organization Name
        </p>
      ),
      cell: (info: any) => (
        <div className="flex justify-start text-sm font-bold text-navy-700 dark:text-white">
          {info.row.original?.organization?.name}

        </div>
      ),
      sortingFn: (rowA, rowB) => {
        const nameA = rowA.original.organization?.name?.toLowerCase() || "";
        const nameB = rowB.original.organization?.name?.toLowerCase() || "";
    
        return nameA.localeCompare(nameB);
      },
      enableSorting: true,
    }),
    columnHelper.accessor("client", {
      id: "client",
      header: () => (
        <p className="flex justify-start text-sm font-bold text-gray-900 dark:text-white">
          Client Name
        </p>
      ),
      cell: (info: any) => (
        <div className="flex justify-start text-sm font-bold text-navy-700 dark:text-white">
          {info?.row.original?.client
            ?.map((m: any) => {
              return m?.name;
            })
            .join(", ")}
        </div>
      ),
      sortingFn: (rowA, rowB) => {
        const nameA = rowA.original.client
          ?.map((m: any) => m?.name)
          .join(", ")
          .toLowerCase() || "";
        const nameB = rowB.original.client
          ?.map((m: any) => m?.name)
          .join(", ")
          .toLowerCase() || "";
    
        return nameA.localeCompare(nameB);
      },
      enableSorting: true,
    }),
    columnHelper.accessor("created_at", {
      id: "created_at",
      header: () => (
        <p className="flex justify-start text-sm font-bold text-gray-900 dark:text-white">
          Created Date
        </p>
      ),
      cell: (info: any) => (
        <div className="flex justify-start text-sm font-bold text-navy-700 dark:text-white">
          {info.row.original?.created_at}
        </div>
      ),
      sortingFn: (rowA, rowB) => {
        return (
          new Date(rowA.original.created_at).getTime() -
          new Date(rowB.original.created_at).getTime()
        );
      },
      enableSorting: true,
    }),
    columnHelper.accessor("total_payout", {
      id: "total_payout",
      header: () => (
        <p className="flex justify-start text-sm font-bold text-gray-900 dark:text-white">
          Total Payout
        </p>
      ),
      cell: (info: any) => (
        <div className="flex justify-start text-sm font-bold text-navy-700 dark:text-white">
          {info?.row?.original?.is_settlement_approved
            ? info.row.original?.total_payout ? "$" + Number(info.row.original?.total_payout)?.toFixed(2) : "" : "-"}
        </div>
      ),
    }),
  ]; 

  React.useEffect(() => {
    setData(tableData);
  }, [tableData]);

  const table = useReactTable({
    data,
    columns:(roleData?.[0]?.settlement?.value?.approve_settlement||roleData?.[0]?.settlement?.value?.download_settlement||roleData?.[0]?.settlement?.value?.edit_settlement||roleData?.[0]?.settlement?.value?.delete_settlement) ?columns:columns2,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  const handleValueChange = (e: any) => {
    onValueChange(e);
    setSearchVal(e);
  };
  const handleApproveClose = () => {
    setUSDTForexRate([])
    setApproveErrors([])
    setTableApproveData(null); 
    setNetPayout({
      usdtForex: null,
      withdrawalFee: null,
      settlementFee: null,
      hash: null,
    });

    setIsCloseAppModal(true)
    setTimeout(() => {
      setIsCloseAppModal(false)
      setIsopenApprove(false);
    }, 300);
  };
  
  const handleClose = () => {
    setDeleteRowId("");
    setIsCloseModal(true)
    setTimeout(() => {
      setIsCloseModal(false)
      setIsopenDelete(false);
    }, 300);
  };

  const validateApproveData = () => {

    let newErrors : any = {};

    if (netPayout.withdrawalFee == null || netPayout.withdrawalFee === "") 
      newErrors.withdrawalFee = "The field is required"; 

    if (Number(netPayout.withdrawalFee) <= 0) 
      newErrors.withdrawalFee = "Value must be greater than 0"; 
  
    if (netPayout.settlementFee == null || netPayout.settlementFee === "") 
      newErrors.settlementFee = "The field is required";

    if (Number(netPayout.settlementFee) <= 0) 
      newErrors.settlementFee = "Value must be greater than 0"; 
  
    if (settlmenetStatus && !netPayout.hash) 
      newErrors.hash = "The field is required";

    let forexErrors: any = {};

    TableApproveData?.settlement_history_details?.forEach((item: any) => {
        const forexEntry = USDTForexRate.find(
          (f: any) => f.currency === item.summary_currency
        );
        if (!forexEntry || forexEntry.forex_rate === "" || forexEntry.forex_rate == null) {
          forexErrors[item.summary_currency] = "The field is required";
        } else if (Number(forexEntry.forex_rate) <= 0) {
          forexErrors[item.summary_currency] = "Value must be greater than 0";
        }
      }
    );
    if (Object.keys(forexErrors).length > 0) {
      newErrors.forex_rate = forexErrors;
    }
    setApproveErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  const handlesubmitApprovedSettlement = () => {
    const validateApprove = validateApproveData()
    if(validateApprove) {
      setIsApproveLoading(true);
      let payload = {
        USDT_forex_rate: USDTForexRate.map((mData: any) => {
          return {
            "currency": mData?.currency,
            "forex_rate": mData?.forex_rate
          }
        }),
        withdrawal_fees: netPayout?.withdrawalFee,
        settlement_fees: netPayout?.settlementFee,
        hash: netPayout?.hash,
        settlement_status:markStatus,
        payout_status:(markStatus == 'approved' && netPayout?.hash) ? "paid" : "unpaid",
        USDT_total_payout: (Number(USDTForexRate?.reduce((total: any, num: any) => {
          return Number(total) + Number(num?.netPayOut)
        }, 0)) - parseFloat(netPayout?.settlementFee || 0) - parseFloat(netPayout?.withdrawalFee || 0))?.toFixed(2) || ""
      };
      approvedSettlement(payload, TableApproveData?.id)
        .then((res) => {
          setIsApproveLoading(false);
          toast.success(res?.message);
          fetchAllsettlement();
          handleApproveClose();
        })
        .catch((error) => {
          setIsApproveLoading(false);
          const errorMessage = error.response.data.message
          toast.error(errorMessage ? errorMessage : error?.message);
        });
    }
  };

  return (
    <Card extra={"w-full h-full sm:overflow-auto px-6 py-4"}>
      <header className="relative flex flex-wrap items-center justify-between pt-5">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          Settlement List
        </div>
        <Searchbox onSearch={handleValueChange} />
      </header>
 
      {isDownloadFile && (
        <div className="z-[1002]  mt-8 text-center text-blue-500">
          {"Please wait downloading...."}
        </div>
      )}

      <div className="relative mt-4 overflow-x-auto overflow-x-auto shadow-md scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-h-1.5 sm:rounded-lg">
        {props.isLoading ? (
          <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
        ) : (
          <table className="w-full w-full text-left text-sm text-gray-500 dark:text-gray-400 rtl:text-right">
            <thead className="bg-gray-50 text-xs uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-400">
              {table.getHeaderGroups().map((headerGroup: any) => (
                <tr
                  key={headerGroup.id}
                // className="!border-px !border-gray-400"
                >
                  {headerGroup.headers.map((header: any) => {
                    return (
                      <th
                        key={header.id}
                        colSpan={header.colSpan}
                        onClick={header.column.getToggleSortingHandler()}
                        className="cursor-pointer border-b-[1px] border-gray-200 p-2 pb-2 pr-4 pt-4 text-start"
                      >
                        <div className="flex items-center text-xs text-gray-200">
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {header.column.getCanSort() && ( // Only show if sorting is enabled
                            <span className="ml-2">
                              {header.column.getIsSorted() === "asc" ? (
                                <BsArrowUp size={14} className="text-gray-900" />
                              ) : header.column.getIsSorted() === "desc" ? (
                                <BsArrowDown size={14} className="text-gray-900" />
                              ) : (
                                <RiArrowUpDownFill size={14} className="text-gray-900" />
                              )}
                            </span>
                          )}
                        </div>
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            <tbody className="">
              {table.getRowModel().rows?.length > 0 ? (
                table.getRowModel().rows.map((row: any) => {
                  return (
                    <tr
                      key={row.id}
                      className="border-b bg-white p-2 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-600"
                    >
                      {row.getVisibleCells().map((cell: any) => {
                        return (
                          <td
                            key={cell.id}
                            // className="min-w-[150px] border-white/0 p-2  py-3 pr-4"
                            className=" border-white/0 p-2  py-3 pr-4"
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={10}>
                    <p className="p-4 text-center">No records found.</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      <Modal isOpen={isOpenDelete} onClose={() => { }}>
        <ModalOverlay className="bg-[#000] !opacity-30" />
          <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${
              isOpenDelete && !isCloseModal ? "card-enter" : "card-exit"
            }`}>
            <ModalHeader className=" flex py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
              <MdHighlightOff
                className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white"
                onClick={handleClose}
              />
              Confirm
            </ModalHeader>
            <ModalBody className="p-4">
                <div className="p-4 bg-yellow-50 border-l-4 border-yellow-400 text-yellow-800 rounded-md shadow-md">
                  <div className="flex items-center">
                    <MdWarning className="w-6 h-6 mr-2 text-yellow-600" />
                    <span className="">
                    Do you want to delete this record?
                    </span>
                  </div>
                </div>
            </ModalBody>
            <ModalFooter className="mt-[10px] p-4">
              <div className="mt-5 flex justify-end gap-2 px-[30px] pb-[30px]">
                <button
                  onClick={handleClose}
                  className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium text-navy-700 outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                  // className="linear rounded-xl bg-indigo-50  px-5 py-2 text-base font-medium text-navy-700 outline-none transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                >
                  Close
                </button>
                {true && (
                  <button
                    onClick={deleteSettlementReportFun}
                    //   disabled={viewMode}
                    className="linear rounded-xl bg-red-100  px-5 py-2 text-base font-medium text-red-600 outline-none transition duration-200 dark:bg-indigo-400/10 dark:text-white dark:hover:bg-indigo-300/10 dark:active:bg-indigo-200/10"
                  > 
                    {isDeleteLoading ? (
                    <DivLoader className="h-6 w-6 border-red-400" />
                    ) : (
                      "Delete"
                    )}
                  </button>
                )}
              </div>
            </ModalFooter>
        </Card>
      </Modal>

      <Modal isOpen={isOpenApprove} onClose={() => { }}>
        <ModalOverlay className="bg-[#000] !opacity-30" />
        <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${
              isOpenApprove && !isCloseAppModal ? "card-enter" : "card-exit"
            }`}>
            <ModalHeader className=" flex py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
              <MdHighlightOff
                className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white"
                onClick={handleApproveClose}
              />
              {TableApproveData?.organization?.name + " - " + "Approve Settlement"}
            </ModalHeader>
          <ModalBody className="p-4">
            {loadingApproveSettlement ? (
              <DivLoader className="h-6 w-6 border-white" />
            ) : (
            <div className=" scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-full scrollbar-w-1 ">
              <div className="w-100 bg-white">
                {TableApproveData?.settlement_history_details?.map((sData: any) => {
                  return <div className="relative mt-2  shadow-md scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-h-1.5 sm:rounded-lg p-3">
                    <div className="mb-3">
                      <span className="font-bold my-1 text-gray-900 bg-gray-500 p-2">
                        {sData?.summary_currency}
                      </span>
                    </div>
                    <table className="w-full w-full text-left text-sm text-gray-900 dark:text-gray-400 rtl:text-right">
                      <thead className="bg-gray-50 text-xs uppercase text-gray-900 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                          {["Total Volume", "Total Deductions", "Total Charges", "Total Held", "Total Reserve", "Net Payout"].map((mdata, index) => {
                            return (
                              <th
                                key={index}
                                className="cursor-pointer border-b-[1px] border-gray-200 p-2 pb-2 pr-4 pt-4 text-start"
                              >
                                <div className="items-center justify-between text-xs text-gray-900">
                                  {mdata}
                                </div>
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody className="">
                        <tr className="border-b bg-white p-2 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-600">
                          <td className=" border-white/0 p-2  px-4 py-3">
                            {`${sData?.summary_report_table_details?.total_volume_count}(${sData?.currency_symbol || ""}${Number(sData?.summary_report_table_details?.total_volume)?.toFixed(2)})`}
                          </td>
                          <td className=" border-white/0 p-2  px-4 py-3">
                            {`${sData?.summary_report_table_details?.total_deductions_count}(${sData?.currency_symbol || ""}${Number(sData?.summary_report_table_details?.total_deductions)?.toFixed(2)})`}
                          </td>{" "}
                          <td className=" border-white/0 p-2  px-4 py-3">
                            {`${sData?.summary_report_table_details?.total_charges_count}(${sData?.currency_symbol || ""}${Number(sData?.summary_report_table_details?.total_charges)?.toFixed(2)})`}
                          </td>{" "}
                          <td className=" border-white/0 p-2  px-4 py-3">
                            {`${sData?.currency_symbol || ""}${Number(sData?.summary_report_table_details?.total_held)?.toFixed(2)}`}
                          </td>{" "}
                          <td className=" border-white/0 p-2  px-4 py-3">
                            {`${sData?.currency_symbol || ""}${Number(sData?.summary_report_table_details?.total_reserve)?.toFixed(2)}`}
                          </td>{" "}
                          <td className=" border-white/0 p-2  px-4 py-3">
                            {`${sData?.currency_symbol || ""}${Number(sData?.summary_report_table_details?.net_payout)?.toFixed(2)}`}
                          </td>{" "}
                        </tr>
                      </tbody>
                    </table>

                    <div className="py-3">
                      <InputField
                        variant=""
                        extra="mt-3 w-full"
                        // value={USDTForexRate?.filter((f: any) => f?.currency == sData?.summary_currency)[0]?.forex_rate}
                        value={USDTForexRate?.find((f: any) => f.currency === sData.summary_currency)?.forex_rate ?? ""}
                        label="USDT Forex Rate *"
                        placeholder="Enter USDT Forex Rate"
                        id={sData?.summary_currency}
                        errMessage={
                          apprveErrors?.forex_rate?.[sData?.summary_currency] || ""
                        }
                        type="Number"
                        onChange={(e) => {
                          const name = e.target.id
                          let value = e.target?.value;
                          value = Number(value)?.toFixed(8);
                          setApproveErrors((prev: any) => ({
                            ...prev,
                            forex_rate: {
                              ...prev?.forex_rate,
                              [name]: ""
                            }
                          }));
                          if (Number(value) >= 0 && Number(value) <= 100) {
                            setUSDTForexRate((prev: any) => {
                              if (prev?.filter((f: any) => f.currency == name)?.length > 0) {
                                return prev?.map((mData: any) => {
                                  if (mData?.currency == name) {
                                    return {
                                      ...mData,
                                      "currency": name,
                                      "forex_rate": Number(value),
                                      "netPayOut": Number(sData?.summary_report_table_details?.net_payout) * Number(value)

                                    }
                                  } else {
                                    return mData
                                  }
                                })
                              } else {
                                let arr: any = []
                                if (prev?.length > 0) {
                                  prev.forEach((element: any) => {
                                    arr.push(element)

                                  });
                                  return [...arr, {
                                    "currency": name,
                                    "forex_rate": Number(value),
                                    "netPayOut": Number(sData?.summary_report_table_details?.net_payout) * Number(value)

                                  }]
                                } else {
                                  return [
                                    {
                                      "currency": name,
                                      "forex_rate": Number(value),
                                      "netPayOut": Number(sData?.summary_report_table_details?.net_payout) * Number(value)

                                    }
                                  ]
                                }
                              }
                            })
                          }
                        }}
                        disabled={settlmenetStatus}
                      />
                      <InputField
                        variant=""
                        extra="mt-3 w-full"
                        value={String(Number(USDTForexRate?.filter((f: any) => { return f?.currency == sData?.summary_currency })[0]?.netPayOut)?.toFixed(2))}
                        label="USDT Net Payout"
                        placeholder="USDT Net Payout"
                        id={sData?.summary_currency}
                        type="Number"
                        disabled
                      />
                    </div>
                  </div>
                })}
              </div>
              <div className="shadow-md py-3 rounded-lg mt-3 px-3" >
                <div>
                  <span className="text-gray-900 px-2 font-bold p-2 bg-indigo-500 text-white">Summary</span>
                </div>
                <div className="w-100">
                  <InputField
                    variant=""
                    extra="mt-4 w-full"
                    value={
                      USDTForexRate?.reduce((total: any, num: any) => {
                        return Number(total) + Number(num?.netPayOut)
                      }, 0)?.toFixed(2)}
                    label="USDT Net Payout"
                    placeholder="USDT Net Payout"
                    id="settlementFee"
                    type="Number"
                    disabled
                  />
                </div>
                <div className="w-100">
                  <InputField
                    variant=""
                    extra="mt-3 w-full"
                    value={netPayout?.settlementFee}
                    disabled={settlmenetStatus}
                    label="Settlement Fee*"
                    placeholder="Enter settlement fee"
                    id="settlementFee"
                    type="Number"
                    errMessage={apprveErrors.settlementFee ? apprveErrors.settlementFee : ""}
                    onChange={(e) => {
                      const name = e.target.id;
                      let value = e.target?.value;
                      value = Number(value)?.toFixed(2);
                      if (Number(value) >= 0) {
                        setNetPayout((prev: any) => {
                          return {
                            ...prev,
                            [name]: Number(value),
                          };
                        });
                      }
                      setApproveErrors((prev: any) => ({
                        ...prev,
                        [name]: (value == "") ? "The field is required" : "",
                      }));
                    }}
                  />
                </div>
                <div className="w-100">
                  <InputField
                    variant=""
                    extra="mt-3 w-full"
                    value={netPayout?.withdrawalFee}
                    label="Withdrawal Fee*"
                    placeholder="Enter withdrawal fee"
                    disabled={settlmenetStatus}
                    id="withdrawalFee"
                    type="Number"
                    errMessage={apprveErrors.withdrawalFee ? apprveErrors.withdrawalFee : ""}
                    onChange={(e) => {
                      const name = e.target.id;
                      let value = e.target?.value;
                      value = Number(value)?.toFixed(2);
                      if (Number(value) >= 0) {
                        setNetPayout((prev: any) => {
                          return {
                            ...prev,
                            [name]: Number(value),
                          };
                        });
                      }
                      setApproveErrors((prev: any) => ({
                        ...prev,
                        [name]: (value == "") ? "The field is required" : "",
                      }));
                    }}
                  />
                </div>
                <div className="w-100  ">
                  <InputField
                    variant=""
                    extra="mt-3 w-full"                    
                    value={
                      String((Number(USDTForexRate?.reduce((total: any, num: any) => {
                        return Number(total) + Number(num?.netPayOut)
                      }, 0)) - parseFloat(netPayout?.settlementFee || 0) - parseFloat(netPayout?.withdrawalFee || 0))?.toFixed(2))}
                    label="USDT Total Payout"
                    placeholder=""
                    id="Calculation"
                    disabled
                  />
                </div>
                <div className="w-100 ">
                  <InputField
                    variant=""
                    extra="mt-3 w-full"
                    value={netPayout.hash}
                    disabled={!settlmenetStatus}
                    label={`Hash ${settlmenetStatus ? "*" : ""}`}
                    placeholder="Enter hash"
                    id="hash"
                    errMessage={apprveErrors.hash ? apprveErrors.hash : ""}
                    onChange={(e) => {
                      const name = e.target.id;
                      const value = e.target?.value;
                      setNetPayout((prev: any) => {
                        return {
                          ...prev,
                          [name]: value,
                        };
                      });
                      setApproveErrors((prev: any) => ({
                        ...prev,
                        [name]: (value == "") ? "The field is required" : "",
                      }));
                    }}
                  />
                </div>
                {/* <div className="w-100 mt-3">
                  <label className="text-sm text-gray-600  dark:text-white ml-3 font-bold text-sm font-bold text-gray-900 dark:text-white">Settlement Status*</label>
                    <div className="flex mt-1">
                        <div className="ml-2 flex items-center">
                            <input
                                type="radio"
                                className="h-4 w-4"
                                id="approved"
                                name="algo"
                                value="approved"
                                checked={markStatus == "approved"}
                                onChange={(e) => {
                                    setMarkStatus("approved");
                                }}
                            />
                            <label
                            htmlFor="approved"
                            className="mx-2 items-center"
                            >
                            Approved
                            </label>
                        </div>
                        <div className="ml-2 flex items-center">
                            <input
                                type="radio"
                                className="h-4 w-4"
                                id="unapproved"
                                name="algo"
                                value="unapproved"
                                checked={markStatus == "unapproved"}
                                onChange={(e) => {
                                    setMarkStatus("unapproved");
                                }}
                            />
                            <label
                            htmlFor="unapproved"
                            className="mx-2 items-center"
                            >
                            Un-Approved
                            </label>
                        </div>
                    </div>
                </div> */}
              </div>
            </div>
            )}
          </ModalBody>
          <ModalFooter className="mt-[10px] p-2">
            <div className="mt-5 flex justify-end gap-2 px-[30px] pb-[30px]">
              <button
                onClick={handleApproveClose}
                className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium text-navy-700 outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
              >
                Close
              </button>
              {true && (
                <button
                  className="linear rounded-xl bg-indigo-600 px-3 py-2  font-medium text-white hover:text-white outline-none transition duration-200 hover:bg-indigo-600/5 active:bg-indigo-700/5 dark:bg-indigo-400/10 dark:text-white dark:hover:bg-indigo-300/10 dark:active:bg-indigo-200/10"
                  onClick={() => {
                    handlesubmitApprovedSettlement();
                  }}
                >
                  {isApproveLoading ? (
                    <DivLoader className="h-6 w-6 border-white" />
                  ) : settlmenetStatus ? (
                    "Mark As Paid"
                  ) : (
                    "Save"
                  )}
                </button>
              )}
            </div>
          </ModalFooter>
        </Card>
      </Modal>

      <Pagination
        setPage={setPage}
        page={page}
        totalpage={totalpage}
        currentPage={currentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        arraySize={[50, 100, 200]}
      />
    </Card>
  );
}

export default SettlementTable;
const columnHelper = createColumnHelper<SettlementRowObj>();
